import React from 'react';
import { colors } from './theme/tokens';

interface ColorSwatchProps {
  colorName: string;
  colorValue: string;
  className?: string;
}

const ColorSwatch: React.FC<ColorSwatchProps> = ({ colorName, colorValue, className = '' }) => {
  return (
    <div className={`border-3 border-osrs-border rounded overflow-hidden ${className}`}>
      <div
        className="h-20 w-full"
        style={{ backgroundColor: colorValue }}
      />
      <div className="bg-osrs-black p-3">
        <div className="text-osrs-gold font-bold">{colorName}</div>
        <code className="text-osrs-yellow text-sm">{colorValue}</code>
      </div>
    </div>
  );
};

interface ColorPaletteProps {
  category?: 'all' | 'primary' | 'ui' | 'text' | 'status';
  className?: string;
}

const ColorPalette: React.FC<ColorPaletteProps> = ({
  category = 'all',
  className = ''
}) => {
  const primaryColors = {
    yellow: colors.yellow,
    gold: colors.gold,
    brown: colors.brown,
    darkBrown: colors.darkBrown,
    black: colors.black,
  };

  const uiColors = {
    background: colors.background,
    border: colors.border,
    panel: colors.panel,
    stone: colors.stone,
    stoneHighlight: colors.stoneHighlight,
    stoneShadow: colors.stoneShadow,
    chatStone: colors.chatStone,
  };

  const statusColors = {
    green: colors.green,
    red: colors.red,
    blue: colors.blue,
  };

  const textColors = {
    yellow: colors.yellow,
    gold: colors.gold,
    chat: colors.chat,
    interfaceText: colors.interfaceText,
  };

  const getColorsToShow = (): Record<string, string> => {
    switch (category) {
      case 'primary':
        return primaryColors;
      case 'ui':
        return uiColors;
      case 'text':
        return textColors;
      case 'status':
        return statusColors;
      case 'all':
        return colors;
      default: {
        const neverCategory: never = category;
        return neverCategory;
      }
    }
  };

  const colorsToShow = getColorsToShow();

  return (
    <div className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ${className}`}>
      {Object.entries(colorsToShow).map(([name, value]) => (
        <ColorSwatch
          key={name}
          colorName={name}
          colorValue={value}
        />
      ))}
    </div>
  );
};

export default ColorPalette;
